import React from 'react';
import styled from '@emotion/styled';
import { TourTrashUserType } from '../../../../types/tourtrash';

interface IndexColumnProps {
  record: TourTrashUserType;
}

export default React.memo((props: IndexColumnProps) => {
  const { record } = props;
  return (
    <StyledContainer>
      <span>{record.fullName}</span>
    </StyledContainer>
  );
});

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  padding-left: 0.5rem;
  span {
    font-weight: 600;
  }
`;
